var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99956 11.5134L10.7662 13.1867C11.2729 13.4934 11.8929 13.04 11.7596 12.4667L11.0262 9.32005L13.4729 7.20005C13.9196 6.81338 13.6796 6.08005 13.0929 6.03338L9.87289 5.76005L8.61289 2.78671C8.38623 2.24671 7.61289 2.24671 7.38623 2.78671L6.12623 5.75338L2.90623 6.02671C2.31956 6.07338 2.07956 6.80671 2.52623 7.19338L4.97289 9.31338L4.23956 12.46C4.10623 13.0334 4.72623 13.4867 5.23289 13.18L7.99956 11.5134Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStar);
export default __webpack_public_path__ + "static/media/filledStar.ef7b4420.svg";
export { ForwardRef as ReactComponent };